"use client";
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { dbFB } from '../../Firebase';
import { query, where, orderBy, collection, getDocs, Timestamp } from 'firebase/firestore/lite';

import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import { Navigation } from 'swiper/modules';

import EventItem from '../../components/event/EventItem';

export default function Home() {
  const [eventos, setEventos] = useState({});
  const [eventosSinFiltrar, setEventosSinFiltrar] = useState({});
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState(null);
  const [categoriasSeleccionadas, setCategoriasSeleccionadas] = useState([]);
  const [todasLasCategorias, setTodasLasCategorias] = useState([]);
  const [isFilterOpen, setIsFilterOpen] = useState(false);

  useEffect(() => {
    async function fetchEventos() {
      const eventosFinales = [];

      try {
        const eventosCol = collection(dbFB, 'eventos');

        const hoyDate = new Date();
        hoyDate.setHours(0, 0, 0, 0);
        const hoy = Timestamp.fromDate(hoyDate);

        const xDiasDespues = new Date(hoyDate);
        xDiasDespues.setDate(xDiasDespues.getDate() + 30);
        xDiasDespues.setHours(23, 59, 59, 999);

        const q = query(
          eventosCol,
          where('fechahora', '<=', Timestamp.fromDate(xDiasDespues)),
          where('fechahorafinal', '>=', hoy),
          orderBy('fechahora', 'asc')
        );

        const snapshot = await getDocs(q);
        const list = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));

        list.forEach(evento => {
          if (!evento.recurrente) {
            eventosFinales.push({ ...evento });
          } else if (
            evento.recurrente === true &&
            evento.fechahora &&
            evento.fechahorafinal &&
            Array.isArray(evento.diassemana)
          ) {
            const inicio = evento.fechahora.toDate();
            const fin = evento.fechahorafinal.toDate();

            for (let fecha = new Date(inicio); fecha <= fin; fecha.setDate(fecha.getDate() + 1)) {
              if (fecha < hoyDate || fecha > xDiasDespues) continue;

              const diaSemana = new Intl.DateTimeFormat('es-EC', { weekday: 'long' }).format(fecha);
              if (evento.diassemana.includes(diaSemana)) {
                const hora = evento.fechahora.toDate().getHours();
                const minutos = evento.fechahora.toDate().getMinutes();
                const fechaConHora = new Date(fecha);
                fechaConHora.setHours(hora, minutos, 0, 0);
                const timestampFinal = Timestamp.fromDate(fechaConHora);

                eventosFinales.push({ ...evento, fechahora: timestampFinal });
              }
            }
          }
        });

        // Extraer todas las categorías únicas
        const categoriasUnicas = [...new Set(eventosFinales.map(evento => evento.categoria).filter(Boolean))];
        setTodasLasCategorias(categoriasUnicas);

        // Agrupar por día
        const agrupados = {};
        let indexDay = 1;
        eventosFinales.forEach(ev => {
          const fecha = ev.fechahora.toDate();
          const diaClave = `${fecha.getFullYear()}-${String(fecha.getMonth() + 1).padStart(2, '0')}-${String(fecha.getDate()).padStart(2, '0')}`;
          if (!agrupados[diaClave]) {
            agrupados[diaClave] = { tabIndex: indexDay++, eventos: [] };
          }
          agrupados[diaClave].eventos.push(ev);
        });

        setEventosSinFiltrar(agrupados);
        setEventos(agrupados);
        const diasKeys = Object.keys(agrupados).sort();
        if (diasKeys.length > 0) setActiveTab(agrupados[diasKeys[0]].tabIndex);
      } catch (error) {
        console.error('Error al obtener eventos:', error);
      } finally {
        setLoading(false);
      }
    }

    fetchEventos();
  }, []);

  // Filtrar eventos cuando cambian las categorías seleccionadas
  useEffect(() => {
    if (categoriasSeleccionadas.length === 0) {
      // Si no hay categorías seleccionadas, mostrar todos
      setEventos(eventosSinFiltrar);
    } else {
      // Filtrar eventos por categorías seleccionadas
      const eventosFiltrados = {};
      let indexDay = 1;

      Object.keys(eventosSinFiltrar).forEach(dia => {
        const eventosDia = eventosSinFiltrar[dia].eventos.filter(evento => 
          categoriasSeleccionadas.includes(evento.categoria)
        );

        if (eventosDia.length > 0) {
          eventosFiltrados[dia] = {
            tabIndex: indexDay++,
            eventos: eventosDia
          };
        }
      });

      setEventos(eventosFiltrados);
      
      // Ajustar activeTab si es necesario
      const diasKeys = Object.keys(eventosFiltrados).sort();
      if (diasKeys.length > 0) {
        setActiveTab(eventosFiltrados[diasKeys[0]].tabIndex);
      }
    }
  }, [categoriasSeleccionadas, eventosSinFiltrar]);

  const handleCategoriaChange = (categoria) => {
    setCategoriasSeleccionadas(prev => {
      if (prev.includes(categoria)) {
        return prev.filter(c => c !== categoria);
      } else {
        return [...prev, categoria];
      }
    });
  };

  if (loading) return <p>Cargando eventos...</p>;

  const dias = Object.keys(eventos).sort();
  const handleTabClick = (tab) => setActiveTab(tab);

  return (
    <div>
      <section className="testimonial-page">
        <div className="section-title text-center">
          <div className="section-title__tagline-box">
            <span className="section-title__tagline">
              Cartelera
            </span>
          </div>
          <h2 className="section-title__title">
            Desliza y No te pierdas nada
          </h2>
        </div>

        {/* Filtro de categorías mejorado */}
        <div className="container">
          <div className="category-filter">
            <div className="category-filter-header" onClick={() => setIsFilterOpen(!isFilterOpen)}>
              <h4>
                <span className="filter-icon">🏷️</span>
                Filtrar por categoría
                <span className={`arrow-icon ${isFilterOpen ? 'open' : ''}`}>▼</span>
              </h4>
            </div>
            
            <div className={`category-dropdown ${isFilterOpen ? 'open' : ''}`}>
              <div className="category-options">
                {todasLasCategorias.map(categoria => (
                  <label key={categoria} className="category-option">
                    <input
                      type="checkbox"
                      checked={categoriasSeleccionadas.includes(categoria)}
                      onChange={() => handleCategoriaChange(categoria)}
                    />
                    <span className="custom-checkbox"></span>
                    <span className="option-text">{categoria}</span>
                  </label>
                ))}
              </div>
              
              {categoriasSeleccionadas.length > 0 && (
                <div className="filter-actions">
                  <button 
                    className="clear-filters-btn"
                    onClick={() => {
                      setCategoriasSeleccionadas([]);
                      setIsFilterOpen(false);
                    }}
                  >
                    Limpiar filtros
                  </button>
                </div>
              )}
            </div>

            {/* Chips de categorías seleccionadas */}
            {categoriasSeleccionadas.length > 0 && (
              <div className="selected-categories">
                {categoriasSeleccionadas.map(categoria => (
                  <div key={categoria} className="category-chip">
                    <span>{categoria}</span>
                    <button 
                      className="remove-chip"
                      onClick={() => handleCategoriaChange(categoria)}
                      aria-label={`Remover ${categoria}`}
                    >
                      ✕
                    </button>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>

        <div className="container" style={{ position: 'relative' }}>
          {/* botones de navegación */}
          <div id="main-slider__swiper-button-prev" className="blog-details__prev-box">
            <Link to="#" className="blog-details__prev-arrow">
              <span className="icon-arrow-left"></span>
            </Link>
          </div>
          <div id="main-slider__swiper-button-next" className="blog-details__next-box">
            <Link to="#" className="blog-details__next-arrow">
              <span className="icon-arrow-right"></span>
            </Link>
          </div>

          {dias.length > 0 ? (
            <Swiper
              spaceBetween={30}
              slidesPerView={1}
              breakpoints={{ 768: { slidesPerView: 1 }, 1200: { slidesPerView: 1 } }}
              navigation={{ nextEl: '#main-slider__swiper-button-next', prevEl: '#main-slider__swiper-button-prev' }}
              modules={[Navigation]}
            >
              {dias.map(dia => {
                const dayData = eventos[dia];
                return (
                  <SwiperSlide key={'slide-' + dia}>
                    <div className="day-slide">
                      <div className="day-header">
                        <div
                          className={`tab-btn ${activeTab === dayData.tabIndex ? 'active-btn' : ''}`}
                          onClick={() => handleTabClick(dayData.tabIndex)}
                        >
                          <h3>{new Date(dia + "T00:00:00").toLocaleDateString('es-EC', { weekday: 'long' })}</h3>
                          <p>{new Date(dia + "T00:00:00").toLocaleDateString('es-EC', { day: 'numeric', month: 'long', year: 'numeric' })}</p>
                          <span className="event-count">
                            {dayData.eventos.length} evento{dayData.eventos.length !== 1 ? 's' : ''}
                          </span>
                        </div>
                      </div>

                      <div className="events-list">
                        {dayData.eventos.map(evento => (
                          <div className="tab" key={'tab-' + evento.id + '-' + evento.fechahora.toMillis()}>
                            <div className="schedule-one__tab-content-box">
                              <EventItem
                                key={'key-' + evento.id + '-' + evento.fechahora.toMillis()}
                                id={'id-' + evento.id + '-' + evento.fechahora.toMillis()}
                                titulo={evento.titulo}
                                subtitulo={evento.subtitulo}
                                descripcion={evento.descripcion}
                                facebook={evento.facebook}
                                instagram={evento.instagram}
                                tiktok={evento.tiktok}
                                imagenPremium0={evento.imagenPremium0}
                                fechahora={evento.fechahora}
                                direccion={evento.direccion}
                                premium={evento.premium}
                                enlace={evento.enlace}
                                contactocell={evento.contactocell}
                                fuente={evento.fuente}
                                geo={evento.geo}
                                categoria={evento.categoria}
                              />
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </SwiperSlide>
                );
              })}
            </Swiper>
          ) : (
            <div className="no-events-message">
              <p>No hay eventos disponibles para las categorías seleccionadas.</p>
            </div>
          )}
        </div>
      </section>
    </div>
  );
}
